import { render } from "./Mb015.vue?vue&type=template&id=070ec706&scoped=true"
import script from "./Mb015.vue?vue&type=script&lang=js"
export * from "./Mb015.vue?vue&type=script&lang=js"

import "./Mb015.vue?vue&type=style&index=0&id=070ec706&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070ec706"]])

export default __exports__